import styled from "styled-components";

export const Container = styled.div`
    box-sizing: border-box;
`;